import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'

import './prototype'

import './components/base'

import './assets/css/fonts.css'
import './assets/scss/main.scss'

import './registerServiceWorker'

Vue.config.productionTip = false

const app = new Vue({
	store,
	router,
	vuetify,
	render: (h) => h(App),
})

app.$mount('#app')
